import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useTranslation } from 'next-i18next';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogOverlay, DialogPanel, DialogTitle } from '@zep/ui';
import { SALES_MAP_EMBED_URLS, SalesMapEmbed } from '../common/SalesMapEmbed';
import S from './Explore.module.scss';
declare global {
  interface Window {
    Tally: {
      loadEmbeds: () => void;
    };
  }
}
const _ExploreInquiryModal = (props: ExploreInquiryProps) => {
  const {
    spaceName,
    partnerName,
    spaceTemplateUrl
  } = props;
  const {
    t
  } = useTranslation(['home']);
  const {
    visible,
    remove
  } = useModal();
  return <Dialog open={visible} onClose={remove} drawer maxWidth={'1140px'} data-sentry-element="Dialog" data-sentry-component="_ExploreInquiryModal" data-sentry-source-file="ExploreInquiryModal.tsx">
      <DialogOverlay data-sentry-element="DialogOverlay" data-sentry-source-file="ExploreInquiryModal.tsx" />
      <DialogPanel data-sentry-element="DialogPanel" data-sentry-source-file="ExploreInquiryModal.tsx">
        <DialogHeader onClose={remove} data-sentry-element="DialogHeader" data-sentry-source-file="ExploreInquiryModal.tsx">
          <div>
            <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="ExploreInquiryModal.tsx">
              {t('home:explore.inquiryModal.title', {
              partnerName
            })}
            </DialogTitle>
          </div>
        </DialogHeader>
        <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="ExploreInquiryModal.tsx">
          <SalesMapEmbed webFormUrl={`${SALES_MAP_EMBED_URLS.도입_문의}?utm_source=explore&utm_medium=home&utm_partner=${partnerName}`} data-sentry-element="SalesMapEmbed" data-sentry-source-file="ExploreInquiryModal.tsx" />
        </DialogContent>
        <DialogFooter className={S.inquiry_space_information} data-sentry-element="DialogFooter" data-sentry-source-file="ExploreInquiryModal.tsx">
          {}
          <img className={S.template} src={spaceTemplateUrl} alt={`${spaceName} space template`}></img>
          <span>
            <span className={S.space_name}>{spaceName} </span>
            {t('home:explore.inquiryModal.message')}
          </span>
        </DialogFooter>
      </DialogPanel>
    </Dialog>;
};
export const ExploreInquiryModal = NiceModal.create(_ExploreInquiryModal);
type ExploreInquiryProps = {
  spaceName: string;
  spaceTemplateUrl: string;
  partnerName: string;
};